import React, { useContext } from 'react'
import { Select, Tooltip } from 'antd'
import { FormattedMessage } from 'react-intl'
import { apiContext } from 'services/ApiContext'
import { useSetProject } from 'services/projects'
import { hasRights } from 'utils'

import './style.scss'
import { useEvents } from 'services/events'
import { byProjects } from 'utils/shares'

const ProjectSelection = () => {
  const { project, projects, userId } = useContext(apiContext)
  const setProject = useSetProject()
  const publishEvent = useEvents()

  // separate my-project / shared-projects
  const myProjects = []
  const sharedProjects = []
  if (projects && userId) {
    projects
      .slice()
      .sort(byProjects)
      .forEach((p) => {
        const membership = p.projectMemberships.find((m) => m.userAccount.userId === userId)

        const option = (
          <Select.Option key={p.id} value={p.id}>
            {p.company ? p.company.name : p.name}
          </Select.Option>
        )

        if (hasRights(membership, 'OWNER')) {
          myProjects.push(option)
        } else {
          sharedProjects.push(option)
        }
      })
  }

  const select = (projectId) =>
    setProject(projectId).then(() => publishEvent('PROJECT', 'PROJECT SWITCH'))
  return (
    <span className="d-flex align-items-center project-selection">
      <Tooltip title={<FormattedMessage id="selectedProject" />} placement="left">
        <Select
          className="mr-3"
          showSearch
          filterOption={(input, option) => {
            if (!option.children || option.options instanceof Array) return false

            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }}
          placeholder={
            <FormattedMessage
              id="pleaseSelectA"
              values={{ name: <FormattedMessage id="project.title" /> }}
            />
          }
          value={project ? project.id : null}
          onChange={select}
        >
          {sharedProjects.length > 0 && (
            <Select.OptGroup
              key="shared-projects"
              label={<FormattedMessage id="portfolio.shared" />}
            >
              {sharedProjects}
            </Select.OptGroup>
          )}
          {myProjects.length > 0 && (
            <Select.OptGroup key="my-projects" label={<FormattedMessage id="portfolio.my" />}>
              {myProjects}
            </Select.OptGroup>
          )}
        </Select>
      </Tooltip>
    </span>
  )
}

export default ProjectSelection
